export var createColorLightTokens = function createColorLightTokens(primitives) {
  return {
    surface: {
      neutral: {
        primary: primitives.neutral[0],
        secondary: primitives.neutral[50],
        tertiary: primitives.neutral[100],
        contrast: primitives.neutral[800],
        black: primitives.neutral[1000]
      },
      informative: {
        success: {
          primary: primitives.informative.success[50],
          secondary: primitives.informative.success[700],
          contrast: {
            primary: primitives.informative.success[700],
            secondary: primitives.informative.success[50]
          }
        },
        alert: {
          primary: primitives.informative.error[50],
          secondary: primitives.informative.error[600]
        },
        info: {
          primary: primitives.informative.info[50],
          secondary: primitives.informative.info[600]
        },
        warning: {
          primary: primitives.informative.warning[50],
          secondary: primitives.informative.warning[700]
        }
      },
      accent: {
        primary: primitives.interaction1[400],
        secondary: primitives.interaction1[50],
        tertiary: primitives.interaction1[800]
      },
      accent2: {
        primary: primitives.interaction2[700],
        secondary: primitives.interaction2[800],
        tertiary: primitives.neutral[0]
      },
      brand: {
        primary: primitives.brand[400],
        secondary: primitives.brand[50]
      }
    },
    text: {
      neutral: {
        primary: primitives.neutral[900],
        secondary: primitives.neutral[500],
        tertiary: primitives.neutral[300],
        contrast: primitives.neutral[0]
      },
      informative: {
        success: {
          primary: primitives.informative.success[700],
          secondary: primitives.informative.success[50]
        },
        alert: {
          primary: primitives.informative.error[600],
          secondary: primitives.informative.error[50]
        },
        info: {
          primary: primitives.informative.info[600],
          secondary: primitives.informative.info[50]
        },
        warning: {
          primary: primitives.informative.warning[700],
          secondary: primitives.informative.warning[50]
        }
      },
      accent: {
        primary: primitives.interaction1[400],
        secondary: primitives.interaction1[50],
        tertiary: primitives.interaction1[800]
      },
      accent2: {
        primary: primitives.interaction2[400],
        secondary: primitives.interaction2[50],
        tertiary: primitives.interaction2[800]
      },
      brand: {
        primary: primitives.brand[400],
        secondary: primitives.brand[50]
      }
    },
    icon: {
      neutral: {
        primary: primitives.neutral[900],
        secondary: primitives.neutral[500],
        tertiary: primitives.neutral[200],
        contrast: primitives.neutral[0]
      },
      informative: {
        success: {
          primary: primitives.informative.success[700],
          secondary: primitives.informative.success[50]
        },
        alert: {
          primary: primitives.informative.error[600],
          secondary: primitives.informative.error[50]
        },
        info: {
          primary: primitives.informative.info[600],
          secondary: primitives.informative.info[50]
        },
        warning: {
          primary: primitives.informative.warning[700],
          secondary: primitives.informative.warning[50]
        }
      },
      accent: {
        primary: primitives.interaction1[400],
        secondary: primitives.interaction1[50],
        tertiary: primitives.interaction1[800]
      },
      accent2: {
        primary: primitives.interaction2[400],
        secondary: primitives.interaction2[50],
        tertiary: primitives.interaction2[800]
      },
      brand: {
        primary: primitives.brand[400],
        secondary: primitives.brand[50]
      }
    },
    border: {
      neutral: {
        primary: primitives.neutral[100],
        secondary: primitives.neutral[200],
        tertiary: primitives.neutral[800],
        contrast: primitives.neutral[0]
      },
      informative: {
        success: {
          primary: primitives.informative.success[700],
          secondary: primitives.informative.success[50]
        },
        alert: {
          primary: primitives.informative.error[600],
          secondary: primitives.informative.error[50]
        },
        info: {
          primary: primitives.informative.info[600],
          secondary: primitives.informative.info[50]
        },
        warning: {
          primary: primitives.informative.warning[700],
          secondary: primitives.informative.warning[50]
        }
      },
      accent: {
        primary: primitives.interaction1[400],
        secondary: primitives.interaction1[50],
        tertiary: primitives.interaction1[800]
      },
      accent2: {
        primary: primitives.interaction2[400],
        secondary: primitives.interaction2[50],
        tertiary: primitives.interaction2[800]
      },
      brand: {
        primary: primitives.brand[400],
        secondary: primitives.brand[50]
      }
    }
  };
};
export var createColorDarkTokens = function createColorDarkTokens(primitives) {
  return {
    surface: {
      neutral: {
        primary: primitives.neutral[800],
        secondary: primitives.neutral[900],
        tertiary: primitives.neutral[600],
        contrast: primitives.neutral[0],
        black: primitives.neutral[1000]
      },
      informative: {
        success: {
          primary: primitives.informative.success[700],
          secondary: primitives.informative.success[50],
          contrast: {
            primary: primitives.informative.success[700],
            secondary: primitives.informative.success[50]
          }
        },
        alert: {
          primary: primitives.informative.error[600],
          secondary: primitives.informative.error[50]
        },
        info: {
          primary: primitives.informative.info[600],
          secondary: primitives.informative.info[50]
        },
        warning: {
          primary: primitives.informative.warning[700],
          secondary: primitives.informative.warning[50]
        }
      },
      accent: {
        primary: primitives.interaction1[400],
        secondary: primitives.interaction1[500],
        tertiary: primitives.interaction1[800]
      },
      accent2: {
        primary: primitives.interaction2[50],
        secondary: primitives.interaction2[800],
        tertiary: primitives.interaction2[800]
      },
      brand: {
        primary: primitives.brand[400],
        secondary: primitives.brand[50]
      }
    },
    text: {
      neutral: {
        primary: primitives.neutral[0],
        secondary: primitives.neutral[200],
        tertiary: primitives.neutral[400],
        contrast: primitives.neutral[900]
      },
      informative: {
        success: {
          primary: primitives.informative.success[50],
          secondary: primitives.informative.success[700]
        },
        alert: {
          primary: primitives.informative.error[50],
          secondary: primitives.informative.error[600]
        },
        info: {
          primary: primitives.informative.info[50],
          secondary: primitives.informative.info[600]
        },
        warning: {
          primary: primitives.informative.warning[50],
          secondary: primitives.informative.warning[600]
        }
      },
      accent: {
        primary: primitives.interaction1[400],
        secondary: primitives.interaction1[50],
        tertiary: primitives.interaction1[800]
      },
      accent2: {
        primary: primitives.interaction2[400],
        secondary: primitives.interaction2[50],
        tertiary: primitives.interaction2[800]
      },
      brand: {
        primary: primitives.brand[400],
        secondary: primitives.brand[50]
      }
    },
    icon: {
      neutral: {
        primary: primitives.neutral[0],
        secondary: primitives.neutral[200],
        tertiary: primitives.neutral[400],
        contrast: primitives.neutral[900]
      },
      informative: {
        success: {
          primary: primitives.informative.success[50],
          secondary: primitives.informative.success[700]
        },
        alert: {
          primary: primitives.informative.error[50],
          secondary: primitives.informative.error[700]
        },
        info: {
          primary: primitives.informative.info[50],
          secondary: primitives.informative.info[600]
        },
        warning: {
          primary: primitives.informative.warning[50],
          secondary: primitives.informative.warning[700]
        }
      },
      accent: {
        primary: primitives.interaction1[50],
        secondary: primitives.interaction1[400],
        tertiary: primitives.interaction1[800]
      },
      accent2: {
        primary: primitives.interaction2[50],
        secondary: primitives.interaction2[400],
        tertiary: primitives.interaction2[800]
      },
      brand: {
        primary: primitives.brand[50],
        secondary: primitives.brand[400]
      }
    },
    border: {
      neutral: {
        primary: primitives.neutral[600],
        secondary: primitives.neutral[300],
        tertiary: primitives.neutral[0],
        contrast: primitives.neutral[900]
      },
      informative: {
        success: {
          primary: primitives.informative.success[50],
          secondary: primitives.informative.success[700]
        },
        alert: {
          primary: primitives.informative.error[50],
          secondary: primitives.informative.error[600]
        },
        info: {
          primary: primitives.informative.info[50],
          secondary: primitives.informative.info[600]
        },
        warning: {
          primary: primitives.informative.warning[50],
          secondary: primitives.informative.warning[700]
        }
      },
      accent: {
        primary: primitives.interaction1[50],
        secondary: primitives.interaction1[400],
        tertiary: primitives.interaction1[800]
      },
      accent2: {
        primary: primitives.interaction2[400],
        secondary: primitives.interaction2[50],
        tertiary: primitives.interaction2[800]
      },
      brand: {
        primary: primitives.brand[50],
        secondary: primitives.brand[400]
      }
    }
  };
};